<template>
    <Container>
      <ConfirmModal v-if="servingSizeForDeletion" item-type="Serving Size" :item-name="servingSizeForDeletion.name" :confirm="confirmDeleteServingSize" :cancel="cancelDeleteServingSize" />
      <FilteredItemList title="Serving Sizes" :fields="fields" :items="allServingSizes" :on-click="goto" :search="true" @delete="askToDeleteServingSize" :actions="{'Add Serving Size': addNewServingSize }" />
    </Container>
</template>

<script>

import {mapActions, mapGetters} from "vuex";
import ConfirmModal from "@/components/dialogs/ConfirmModal";
import {actionIf, delayedIfLoading} from "@/lib/Async";
import FilteredItemList from "@/components/ui/lists/FilteredItemList";
import Container from "@/components/ui/layout/Container";
import Icons from "@/lib/Icons";

export default {
  name: "ServingSizes",
  components: {Container, FilteredItemList, ConfirmModal },

  data() {
    return {
      servingSizeForDeletion: null,
      search : "",
      fields : [
        {label: "#", prop: "id", sortable: true, width: "60px" },
        {label: "Name", prop: "name", primary: true, sortable: true},
        {label: "Amount (G)", prop: "amount_g", width: "10%", sortable: true},
        {label: "Actions", prop: "", width: "10%", actions: [
            { mood: "danger", icon: Icons.x, action: "delete", tooltip: "Delete" }
          ]}
      ]
    }
  },

  computed: {
    ...mapGetters(['isLoggedIn', 'allServingSizes']),
  },

  async mounted() {
    await delayedIfLoading(!this.isLoggedIn, actionIf([!this.allServingSizes.length, this.getServingSizes]), this.setLoading,
        () => this.isLoggedIn, () => this.$router.push('/'))
  },

  methods: {
    ...mapActions(['getServingSizes','setLoading','deleteServingSize']),
    goto(servingSize) {
      this.$router.push('/serving-size/'+servingSize.id)
    },
    addNewServingSize() {
      this.$router.push('/serving-size/new')
    },
    askToDeleteServingSize(servingSize) {
      this.servingSizeForDeletion = servingSize;
    },
    cancelDeleteServingSize() { this.servingSizeForDeletion = null },
    confirmDeleteServingSize() {
      this.deleteServingSize(this.servingSizeForDeletion.id)
      this.servingSizeForDeletion = null
    }
  },
}
</script>
